import React from 'react';
import { Chip } from '@mui/material';
import { dashboardAccessMeta } from '../utils/dashboardAccess';

const DashboardAccessChip = ({ dashboard, accessLevel, size = 'small', variant = 'outlined', sx }) => {
  const meta = dashboardAccessMeta(
    dashboard || (accessLevel != null ? { accessLevel } : null)
  );
  if (!meta.label) return null;

  return (
    <Chip
      label={meta.label}
      size={size}
      color={meta.chipColor}
      variant={variant}
      sx={sx}
    />
  );
};

export default DashboardAccessChip;
